import { Typography } from '@recruit-robin/robin-theme/web-components';
import { RequirementField } from 'clients/Communication/Questionnaire.dto';
import { memo } from 'react';
import { useStyles } from '../CandidateQuestionnaireScreen.styles';
import { useQuestion } from '../hooks/useQuestion';

const QuestionComponent = ({
  question,
  children,
  rightAdornment,
}: {
  question: RequirementField<any>;
  children: React.ReactNode;
  rightAdornment?: React.ReactNode;
}) => {
  const { getQuestionText } = useQuestion();
  const classes = useStyles({});

  return (
    <div css={classes.questionGroup}>
      <div css={classes.answerInput}>
        <div css={classes.questionHeader}>
          <Typography variant={(v) => v.heading[6]} color={(c) => c.neutral.variant[70]}>
            {getQuestionText(question.question_key, question.is_answered, question.unit)}
          </Typography>
          {rightAdornment && rightAdornment}
        </div>
        {children}
      </div>
    </div>
  );
};

export const Question = memo(QuestionComponent);
